import { getEnv } from './env';

const DEFAULT_SITE_URL = 'https://www.dohockey.app';

export const getSiteBaseUrl = (): string => {
  const configuredUrl = getEnv('VITE_SITE_URL', DEFAULT_SITE_URL).replace(/\/+$/, '');
  return configuredUrl || DEFAULT_SITE_URL;
};

export const getSiteUrl = (path = ''): string => {
  const normalizedPath = path && !path.startsWith('/') ? `/${path}` : path;
  return `${getSiteBaseUrl()}${normalizedPath}`;
};

export const getAuthenticatedSiteUrl = (path = ''): string => {
  return getSiteUrl(path);
};
